import { css } from '@emotion/css';

const styles = {
  container: css`
    display: flex;
    justify-content: center;
    height: 100%;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    width: 100%;
  `,
  content: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    flex: 1 1;
  `,
  column: css`
    position: relative;
    width: 100%;
    max-width: 530px;
  `,
  footer: css`
    width: 100%;
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    background-color: var(--color-background-default);
    padding: 16px;
  `,
  submitFooter: css`
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 530px;
  `,
  radiosLabel: css`
    display: block;
    line-height: 20px;
    font-size: 1.4rem;
    font-weight: 600;
    padding-bottom: 4px;
  `,
  radios: css`
    display: flex;
    align-items: center;
  `,
  row: css`
    margin-bottom: 11px;
  `,
  disclaimer: css`
    display: flex;
    font-size: 12px;
    margin-bottom: 24px;
  `,
  loaderContainer: css`
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  lightgray: css`
    color: var(--gray-800);
  `,
};

export default styles;
